import { Link, useNavigate } from "react-router-dom"
import IMAGES from "../../../../assets/images/images"
import Shimmer from "../../../../components/shimmer/Shimmer"
import { WIDGET_NAME } from "../../../../utils/constants/homeConstants"
import styles from "./broadCastWidget.module.css"
import { connect } from "react-redux"
import { useEffect, useState } from "react"
import BroadCastPopup from "../../../../components/broadCastPopup/broadcastPopup"
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip"
import { getScheduledBroadcast } from "../../../../redux/actions/home/home.action"
import EmptyDataView from "../../../../components/emptydataview/EmptyDataView"
import { dashboardTime, formatDate } from "../../../../utils/arrayUtils"
const BroadCastWidget = ({action,scheduledBroadCastMessage,...props}) => {
    const navigate = useNavigate()
    const data = scheduledBroadCastMessage?.scheduledMessages || [];
    const [currentIndex, setCurrentIndex] = useState(0);
    const totalSteps = data?.length;
    const [showPopup, setShowPopup] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const handleNext = () => {
        if (currentIndex < data?.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };
    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };    
    const gotoDetail = () => {
        switch (action) {
            case WIDGET_NAME.SCHEDULED_BROADCAST_MESSAGE_WIDGET:
                return "/broadcast";
            default:
                return "#";
        }
    }

    const handleClick = (item) => {
        setShowPopup(true);
        setActiveItem(item)
      };
      const handleCancel = () => {
        setShowPopup(false);
        setActiveItem(null)
      };

    useEffect(()=>{
        if(action===WIDGET_NAME.SCHEDULED_BROADCAST_MESSAGE_WIDGET){
            props?.getScheduledBroadcast(WIDGET_NAME.SCHEDULED_BROADCAST_MESSAGE_WIDGET)
        }
    },[])

    const handleRetry = (type) => {
        const retryActions = {
        [WIDGET_NAME.SCHEDULED_BROADCAST_MESSAGE_WIDGET]: props.getScheduledBroadcast,
        };
    
        const retryFn = retryActions[type];
        if (retryFn) {
        retryFn(type);
        }
    };

    return (
        <>
        {showPopup&&
          <BroadCastPopup
          header={activeItem.title}
          data={activeItem.message}
          onCancel={handleCancel}
          showPopup={showPopup}
        />}
        {props?.isLoading?<Shimmer/>:
        <div className={styles.broadcast}>
            <div className={styles.broadcastheader}>
                <div className={styles.header}>
                    <div className={styles.imageheader}>
                        <img src={IMAGES.boradcastopen} className={styles.boradcasticon} />
                    </div>
                    <div className={styles.headertext}>Broadcast Message</div>
                </div>
                {data?.length===0?
                <div className={styles.retryparent} onClick={()=>handleRetry(action)}> <div className={styles.retryicon}></div><div className={styles.refresh}>Refresh</div></div>:
                <Link to={gotoDetail()} target="_blank" rel="noopener noreferrer" className={styles.viewdetailsparent}> <div className={styles.viewdetailicon}></div><div className={styles.detailtext}>View Details</div></Link>
                 }
            </div>
            {data?.length===0?<div className={styles.emptywrapper}><EmptyDataView/></div>:
            <>
            <div className={styles.broadcastbodywrapper}>
                {currentIndex > 0 && <span className={`${styles.leftarrow} ${styles.arrowparent}`} onClick={() => handlePrevious()}><img src={IMAGES.montharrow} className={styles.arrowicon} /></span>}
                <div className={styles.broadcastbody}>
                    <div className={styles.wrapper}>
                        <div className={styles.statuswrapper}>
                            <span className={styles.roundicon}></span>
                            <SecondaryTooltip text={data[currentIndex]?.title} positions={['bottom', 'right']}> 
                                <div className={styles.statustext}>{data[currentIndex]?.title}</div>
                            </SecondaryTooltip>
                        </div>
                    </div>
                    <div className={styles.textarea}>
                        <div className={styles.text}>{data[currentIndex]?.message}</div>
                        <div className={styles.broadcastlink} onClick={() => handleClick(data[currentIndex])}>Check out now</div>
                        <div className={styles.duration}>
                            <div className={styles.timeimage}></div>
                            <div className={styles.datetext}>
                                <span className={styles.datevalue}>{formatDate(data[currentIndex]?.timePeriod?.start)} <div className={styles.timearrow}></div> {formatDate(data[currentIndex]?.timePeriod?.end)}</span></div>
                            </div>
                        </div>
                </div>
                {currentIndex < totalSteps - 1 && <span className={`${styles.rightarrow}  ${styles.arrowparent}`} onClick={() => handleNext()}><img src={IMAGES.montharrow} className={styles.arrowicon} /></span>}
            </div>
            {data?.length>1&&(
                <div className={styles.dotPagination}>
                    {data.map((_, index) => (
                        <span key={index} className={`${styles.dot} ${currentIndex === index ? styles.activeDot : ''}`} onClick={() => setCurrentIndex(index)}/>
                    ))}
                </div>)}
            </>}
        </div>
        }
        </>
    )
}
const mapStateToProps = (state) => {
  return {
    scheduledBroadCastMessage:state?.dashBoardCounts?.scheduledBroadCastMessage?.data,
    isLoading:state?.dashBoardCounts?.scheduledBroadCastMessage?.isLoading,
  }
}
const mapDispatchToProps = (dispatch)=>{
  return {
    getScheduledBroadcast: (action) => {
        return dispatch(getScheduledBroadcast(action))
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BroadCastWidget)